import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Store from "@/pages/Store";
import Checkout from "@/pages/Checkout";
import OrderStatus from "@/pages/OrderStatus";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Products from "@/pages/admin/Products";
import Coupons from "@/pages/admin/Coupons";
import Admins from "@/pages/admin/Admins";
import Settings from "@/pages/admin/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Store />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pedido/:id" element={<OrderStatus />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="pedidos" element={<Orders />} />
              <Route path="produtos" element={<Products />} />
              <Route path="cupons" element={<Coupons />} />
              <Route path="administradores" element={<Admins />} />
              <Route path="configuracoes" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
